import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { CustomVisibilitySensor, Title } from 'components';
import {
  Wrapper,
  BackgroundImage,
  OverlayImage,
  Grid,
  Content
} from './styles';
import { StyledSubtitle } from '../styles';

interface OwnProps {
  customStyle?: string;
  image: any;
  imageStyle: string;
  subtitle: any;
  title: any;
}

export default function SolucoesTopBanner({
  children,
  image,
  imageStyle,
  subtitle,
  title,
  ...props
}: PropsWithChildren<OwnProps>) {
  return (
    <CustomVisibilitySensor partialVisibility>
      {({ isVisible }) => (
        <Wrapper {...props}>
          <BackgroundImage
            alt=""
            className="desktop"
            src={require('assets/solucoes-trapezio-topo.svg')}
          />
          <BackgroundImage
            alt=""
            className="mobile"
            src={require('assets/solucoes-trapezio-topo-mobile.svg')}
          />
          <OverlayImage
            className={classNames({ isVisible })}
            styleProps={{ imageStyle }}
            src={image}
          />
          <Grid className="grid">
            <Content>
              <StyledSubtitle>{subtitle}</StyledSubtitle>
              <Title>{title}</Title>
              {children}
            </Content>
          </Grid>
        </Wrapper>
      )}
    </CustomVisibilitySensor>
  );
}
